import CaptureGroupEventCodeSnippet from "../../../../contents/docs/_snippets/capture-group-event-code.mdx";
import * as React from 'react';
export default {
  CaptureGroupEventCodeSnippet,
  React
};